<div class="container pt-5 bg-grey">
  <div class="row justify-content-center row-shadow">
    <div class="col-12 col-lg-10">
      <div class="cmp-hero">
        <section class="it-hero-wrapper bg-grey align-items-start">
          <div class="it-hero-text-wrapper pt-0 ps-0 pb-4 pb-lg-60">
            <h1 class="text-black" data-element="page-name">
              Informazioni e preferenze sui cookie
            </h1>
            <div class="hero-text">
              <p>
                I cookie sono piccoli file di testo che i siti web visitati
                inviano al device dell'utente, dove vengono memorizzati per
                raccogliere informazioni attraverso il browser, per essere poi
                ritrasmessi agli stessi siti nelle visite successive. Sono
                utilizzati essenzialmente per misurare e migliorare la qualità
                dei siti attraverso l'analisi del comportamento dei visitatori.
              </p>
            </div>
          </div>
        </section>
        <div>
          <div class="row">
            <div class="col-12">
              <div class="form-check form-check-group">
                <div class="toggles">
                  <label for="toggleTecnici">
                    Cookie tecnici essenziali
                    <input
                      disabled
                      type="checkbox"
                      id="toggleTecnici"
                      aria-labelledby="toggleTecnici-help"
                      checked
                    />
                    <span class="lever"></span>
                  </label>
                </div>
                <small id="toggleTecnici-help" class="form-text">
                  Sono necessari al corretto funzionamento del sito. Consentono
                  la navigazione delle pagine e la memorizzazione delle sessioni
                  di un utente (per mantenerle attive durante la navigazione).
                  Senza questi cookie non potrebbero essere erogati i servizi e
                  le funzionalità per cui gli utenti accedono al sito.</small
                >
              </div>
              <div class="form-check form-check-group">
                <div class="toggles">
                  <label for="toggleTerzeParti">
                    Cookie di terze parti
                    <input
                      type="checkbox"
                      id="toggleTerzeParti"
                      aria-labelledby="toggleTerzeParti-help"
                      (change)="onTerzePartiChange()"
                      checked
                    />
                    <span class="lever"></span>
                  </label>
                </div>
                <small id="toggleTerzeParti-help" class="form-text">
                  cookie di terze parti vengono utilizzati per analizzare le
                  caratteristiche della navigazione dell’utente, per fornirgli
                  servizi di visualizzazione di contenuti o di condivisione
                  degli stessi e per creare profili in base al suo comportamento
                  sul sito. Questo sito incorpora contenuti multimediali tramite
                  provider di terze parti (ad esempio YouTube o Facebok)
                  utilizzando le specifiche oEmbed o widget di integrazione.
                  Ciascun provider di contenuti potrebbe rilasciare cookie
                  tecnici, analitici e di profilazione in base alle proprie
                  impostazioni. Se questa impostazione è disabilitata i
                  contenuti multimediali non saranno automaticamente incorporati
                  nel sito e sarà invece esposto un link per poterli
                  visualizzare direttamente alla fonte.</small
                >
              </div>
            </div>
          </div>

          <div class="ccm__footer row mt-3 mb-5">
            <div class="col-xs-12 col-md-4 mb-2">
              <button
                class="consent-refuse btn btn-md btn-info"
                data-focus-mouse="false"
                (click)="refuseAllCookies()"
              >
                Rifiuta tutti i cookie e chiudi
              </button>
            </div>
            <div class="col-xs-12 col-md-4 mb-2">
              <button
                id="ccm__footer__consent-modal-submit"
                class="btn btn-md btn-info"
                (click)="saveSettings()"
              >
                Salva le impostazioni selezionate
              </button>
            </div>
            <div class="col-xs-12 col-md-4 mb-2">
              <button
                class="consent-give btn btn-md btn-info"
                (click)="acceptAllCookies()"
              >
                Accetta tutti i cookie e chiudi
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
